/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { HighResolutionText } from '@appCanvasCommon/text/HighResolutionText';
import { FancyTextStyle } from '@appCanvasCommon/interfaces/fancy-text-style.interface';
import { FancyText } from '@appCanvasCommon/fontpath/FancyText';
import { WORD_WRAP_MODE } from '@appCanvasCommon/fontpath/WordWrapper';

import { InsertionPointLabelTextConfiguration } from './InsertionPointLabelContainer';

export class InsertionPointLabelHighResolutionText extends HighResolutionText {
	constructor(text: string, configuration: InsertionPointLabelTextConfiguration) {
		super(
			text,
			new FancyTextStyle({
				fontSize: configuration.fontSize,
				fill: configuration.fill,
				fontFamily: configuration.fontFamily,
			})
		);
	}
}

export class InsertionPointLabelFancyText extends FancyText {
	constructor(text: string, configuration: InsertionPointLabelTextConfiguration) {
		super(configuration.fontFamily, text, {
			fontSize: configuration.fontSize,
			wordWrapOptions: {
				mode: WORD_WRAP_MODE.NO_WRAP,
			},
		});

		this.active = true;
		this.tint = configuration.fill;
	}
}
